import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=5564c67e&"
import script from "./Project.vue?vue&type=script&lang=js&"
export * from "./Project.vue?vue&type=script&lang=js&"
import style0 from "./Project.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5564c67e')) {
      api.createRecord('5564c67e', component.options)
    } else {
      api.reload('5564c67e', component.options)
    }
    module.hot.accept("./Project.vue?vue&type=template&id=5564c67e&", function () {
      api.rerender('5564c67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/Project.vue"
export default component.exports